import axios from "axios";

export const dangKyVay = (headers, data) => {
  return axios.post(
    `${process.env.REACT_APP_API_URL_CREATE_LEAD}/auth/create-lead`,
    data,
    {
      headers,
    }
  );
};
